<template>
  <div class="mt-4">
    <h1>List of Plans Available</h1>
    <vs-table>
      <template #header>
        <vs-input v-model="search" border placeholder="Search">
          <template #icon>
            <span class="material-symbols-outlined"> search </span>
          </template>
        </vs-input>
        <div class="flex w-500">
          <vs-button
            @click="$router.push('/createManageService').catch(() => {})"
            class="create-manage-service"
            >Change Plan</vs-button
          >
        </div>
      </template>
      <template #thead>
        <vs-tr>
          <vs-th style="width: 16%"> Plan Id </vs-th>
          <vs-th style="width: 20%"> Service Name </vs-th>
          <vs-th> Description </vs-th>
          <vs-th>
            Charge Cycle
          </vs-th>

          <vs-th> Price </vs-th>
        </vs-tr>
      </template>
      <template #tbody>
        <vs-tr
          :key="i"
          v-for="(tr, i) in $vs.getSearch(manageList, search)"
          :data="tr"
        >
          <vs-td>
            {{ tr.id }}
          </vs-td>
          <vs-td>
            {{ tr.planCode }}
          </vs-td>
          <vs-td>
            {{ tr.planDescription }}
          </vs-td>
          <vs-td>
            {{ tr.chargeCycle }}
          </vs-td>

          <vs-td>{{ tr.price }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import moment from "moment";
export default {
  components: {},
  data: () => ({
    search: "",
    selectedMonth: "",
    usageOptions: [{ text: "Current Month", value: 0 }]
  }),
  computed: {
    isLogin() {
      return this.$store.getters["auth/isLogin"];
    },
    userInfo() {
      return this.$store.getters["auth/getUser"];
    },
    manageList() {
      return this.$store.getters["dashboard/getManageServiceList"];
    }
  },

  methods: {
    dueDate(date) {
      return moment(date)
        .subtract(0, "month")
        .add(30, "day")
        .format("DD-MM-YYYY");
    },
    async getEntityList(data) {
      try {
        const payload = {
          id: this.userInfo.firstTimeLogInRemaining,
          clientId: this.userInfo.clientId,
          clientServiceId: this.userInfo.clientOrdersData[0].clientServiceId,
          planPoId: this.userInfo.clientOrdersData[0].planPoId
        };
        await this.$store.dispatch("dashboard/getManageServiceList", payload);
      } catch (e) {}
    }
  },
  filters: {
    dateFormat: function(value) {
      if (!value) return "";

      return moment(value)
        .subtract(1, "month")
        .format("DD-MM-YYYY");
    }
  },
  mounted() {
    this.getEntityList();
  }
};
</script>
<style lang="scss" scoped>
.invoice-card {
  background: linear-gradient(135deg, #6572bb 0%, #2b3674 100%);
  width: 100%;
  padding: 20px;
  color: #ffffff;
  border-radius: 16px;
}
.amount {
  font-size: 22px;
  font-weight: 700;
  margin-top: 5px;
}
.pay-now {
  margin-left: 5rem;
  background: #fff;
  color: #2b3674;
  padding: 2px 10px;
}
.create-manage-service {
  margin-left: 12rem;
  background: #ff6914;
  color: #fff;
  padding: 2px 10px;
}
.w-300 {
  width: 300px;
  max-width: 40%;
  max-height: 35px;
}
@media (max-width: 300px) {
  .pay-now {
    margin-left: 3rem;
  }
}
</style>
